export enum OdcType {
  ODC,
  Rail,
  Port,
  CrossDock,
  EPC,
}

export const odcTypeAsString = new Map([
  [OdcType.ODC, "ODC"],
  [OdcType.Rail, "Rail Terminal"],
  [OdcType.Port, "Ferry Port"],
  [OdcType.CrossDock, "Cross Dock"],
  [OdcType.EPC, "EPC"],
]);
